import Day30Menu from "./OutcomesMenu/Day30Menu";
import LongTermMenu from "./OutcomesMenu/LongTermMenu";

interface OutcomesMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const OutcomesMenu: React.FC<OutcomesMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  return (
    <>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">
            Long Term Outcomes{" "}
          </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <LongTermMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></LongTermMenu>
          </p>
        </div>
      </div>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">
            Post-SRT Complications{" "}
          </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <Day30Menu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></Day30Menu>
          </p>
        </div>
      </div>
    </>
  );
};

export default OutcomesMenu;
